export default __webpack_public_path__ + "static/media/printicon.695c9eb4.svg";